import { Routes } from "@angular/router";
import { MedLocales, MedLocalizationFilePath } from "../types";

/**
 * Add tag locale to all routes
 * Before: /ui-kit
 * After: /en/ui-kit
 * Route "path: '',  pathMatch: 'full' " add automatic
 */
export const medLocalizeRoutes = (list: Routes, activeLocale: keyof MedLocales, locales: MedLocales, localizationFiles: MedLocalizationFilePath[] = []): Routes => {
  const routes: Routes = [{
    path: "",
    pathMatch: "full",
    redirectTo: activeLocale as string,
  }];

  Object.values(locales).forEach(locale => routes.push({
    path: locale,
    children: list.concat([]),
    data: { localizationFiles },
  }));

  return routes;
};
